module.exports = "../../static/img/3.7d42138.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_carousel/3.jpg
// module id = SLlz
// module chunks = 1